export const WEBSITE_RATIO_LABELS = {
  LANDSCAPE_2_1: '2:1 (landscape)',
  LANDSCAPE_4_3: '4:3 (landscape)',
  SQUARE_1_1: '1:1 (square)',
  POSTER_3_4: '3:4 (short poster)',
  POSTER_11_17: '11:17 (full poster)'
};

// Numeric aspect ratios (width / height) matching Ruby VenueOwnership::RATIO_UNITS
export const WEBSITE_RATIO_VALUES = {
  LANDSCAPE_2_1: 2 / 1,
  LANDSCAPE_4_3: 4 / 3,
  SQUARE_1_1: 1 / 1,
  POSTER_3_4: 3 / 4,
  POSTER_11_17: 11 / 17
};

export const WEBSITE_IMAGE_RATIOS = Object.keys(WEBSITE_RATIO_LABELS);

export const WEBSITE_RATIO_OPTIONS = Object.entries(WEBSITE_RATIO_LABELS).map(([value, label]) => ({
  value,
  label
}));

// Helper function to get numeric aspect ratio from ratio key
export const getAspectRatioValue = (ratioKey) => {
  return WEBSITE_RATIO_VALUES[ratioKey] || WEBSITE_RATIO_VALUES.LANDSCAPE_2_1;
};


